export default "__VITE_ASSET__ESd4lJWu__"